













































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import RisikoJatuh from "@/components/pemeriksaan/assesmen/RisikoJatuh.vue";
import RiwayatSkriningRisikoJatuh from "@/components/pemeriksaan/assesmen/skriningrisikojatuh/RiwayatSkriningRisikoJatuh.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import DataSkriningRisikoJatuh from "@/services/DataSkriningRisikoJatuh";
import { storeSkriningRisikoJatuh } from "@/store/modules/skriningrisikojatuh";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import moment from "moment";

@Component({
  components: {
    RisikoJatuh,
    PerawatAutoComplete,
    TimeStamp,
    RiwayatSkriningRisikoJatuh
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSkriningRisikoJatuh extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  time = moment().format("HH:mm:ss");
  maxDate = new Date().toISOString().substr(0, 10);
  today = moment().format("YYYY-MM-DD");
  perawat = {};
  saving = false;

  risiko1 = null;
  risiko2 = null;
  waktu_periksa = null;
  petugas_id = null;
  id = null;
  petugas = {
    id: null,
    nama: null
  };

  mounted() {
    this.waktu_periksa = this.today + " " + this.time;
    // RAL-040: prefill petugas = perawat yang login (petugas_id FK ke User.id),
    // hilangkan "ketik nama" untuk record baru; tetap editable, watcher record
    // existing menimpa saat data tersimpan dimuat.
    if (!this.id && !this.petugas.id && this.sessLogin) {
      this.petugas = { id: this.sessLogin.id, nama: this.sessLogin.nama };
      this.petugas_id = this.sessLogin.id;
    }
  }

  setTime(val) {
    // this.time = val;
    console.log("set time", val);
    this.waktu_periksa = val;
  }

  get sendData() {
    return {
      id: this.id,
      risiko1: this.risiko1,
      risiko2: this.risiko2,
      petugas_id: this.petugas_id,
      waktu_periksa: this.waktu_periksa
    };
  }

  get sessLogin() {
    return userModule.user;
  }
  get stateSkriningRisikoJatuh() {
    return storeSkriningRisikoJatuh.risikoJatuh;
  }
  get stateRiwayatSkrining() {
    return storeSkriningRisikoJatuh.riwayatSkrining;
  }

  @Watch("stateSkriningRisikoJatuh")
  valSkriningRisikoJatuh(val) {
    if (val) {
      this.id = val.id;
      this.risiko1 = val.risiko1;
      this.risiko2 = val.risiko2;
      this.petugas_id = val.petugas_id;
      this.waktu_periksa = val.waktu_periksa;
      this.petugas = val.petugas;
    }
  }

  setPerawat(val) {
    this.petugas = val;
    this.petugas_id = val.id;
  }

  save() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.saving = true;
      const getparam = {
        unit_id: this.sessLogin.unit_id,
        reg: this.register
      };
      if (this.id) {
        const dt = DataSkriningRisikoJatuh.editDataSkriningRisikoJatuh(
          this.sendData.id,
          this.register,
          this.rm,
          this.sessLogin.unit_id,
          this.sendData.risiko1,
          this.sendData.risiko2,
          this.sendData.waktu_periksa,
          this.sendData.petugas_id
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            storeSkriningRisikoJatuh.actRisikoJatuhByRm(this.rm);
            storeSkriningRisikoJatuh.actRisikoJatuhByUnitAndReg(getparam);
            appModule.NoticeDelay("Berhasil Ubah Skrining Risiko Jatuh");
          }
        })
          .catch(err => {
            ErrorAlert.showErrorAlert(err);
          })
          .finally(() => (this.saving = false));
      } else {
        console.log("simpan");
        const dt = DataSkriningRisikoJatuh.saveDataSkriningRisikoJatuh(
          this.register,
          this.rm,
          this.sessLogin.unit_id,
          this.sendData.risiko1,
          this.sendData.risiko2,
          this.sendData.waktu_periksa,
          this.sendData.petugas_id
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            storeSkriningRisikoJatuh.actRisikoJatuhByRm(this.rm);
            storeSkriningRisikoJatuh.actRisikoJatuhByUnitAndReg(getparam);
            appModule.NoticeDelay("Berhasil Simpan Skrining Risiko Jatuh");
          }
        })
          .catch(err => {
            ErrorAlert.showErrorAlert(err);
          })
          .finally(() => (this.saving = false));
      }
    }
  }
  cetak() {
    const routeData =
      http.getAPI() + "/skrining-risiko-jatuh-ralan/pasien/" + this.rm + "/pdf";
    window.open(routeData, "_blank");
  }
}
